var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.014 15V12.866H0.88V11.623H3.014V9.5H4.257V11.623H6.38V12.866H4.257V15H3.014Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3329 9.47053C14.3329 11.1064 13.0068 12.4325 11.3709 12.4325C9.73506 12.4325 8.40894 11.1064 8.40894 9.47053C8.40894 7.83467 9.73506 6.50854 11.3709 6.50854C13.0068 6.50854 14.3329 7.83467 14.3329 9.47053Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.371 13.6208C6.60929 13.6208 5.69507 15.9684 5.69507 16.7214C5.69507 17.4733 6.31539 17.8997 6.89487 17.8997H15.8474C16.4265 17.8997 17.0469 17.4736 17.0469 16.7214C17.0469 15.9684 16.1325 13.6208 11.371 13.6208H11.371Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsers);
export default __webpack_public_path__ + "static/media/add-users.8cbe9622d07b78062f4d58e228b42701.svg";
export { ForwardRef as ReactComponent };